export enum SalesAreaId {
  // Czech Republic
  CZE_PRAGUE = 1,
  CZE_KARLOVY_VARY = 2,
  CZE_CENTRAL_BOHEMIA = 3,
  CZE_VYSOCINA = 4,
  CZE_OLOMOUC = 5,
  CZE_MORAVIA_SILESIA = 6,
  CZE_SOUTH_BOHEMIA = 7,
  CZE_PLZEN = 8,
  CZE_ZLIN = 9,
  CZE_SOUTH_MORAVIA = 10,
  CZE_PARDUBICE = 11,
  CZE_HRADEC_KRALOVE = 12,
  CZE_USTI = 13,
  CZE_LIBEREC = 14,

  // Slovakia
  SVK_BRATISLAVA = 15,
  SVK_TRNAVA = 16,
  SVK_TRENCIN = 17,
  SVK_NITRA = 18,
  SVK_ZILINA = 19,
  SVK_BANSKA_BYSTRICA = 20,
  SVK_PRESOV = 21,
  SVK_KOSICE = 22,

  // Poland
  POL_DOLNOSLASKIE = 23,
  POL_KUJAWSKO_POMORSKIE = 24,
  POL_LODZKIE = 25,
  POL_LUBELSKIE = 26,
  POL_LUBUSKIE = 27,
  POL_MALOPOLSKIE = 28,
  POL_MAZOWIECKIE = 29,
  POL_OPOLSKIE = 30,
  POL_PODKARPACKIE = 31,
  POL_PODLASKIE = 32,
  POL_POMORSKIE = 33,
  POL_SLASKIE = 34,
  POL_SWIETOKRZYSKIE = 35,
  POL_WARMINSKO_MAZURSKIE = 36,
  POL_WIELKOPOLSKIE = 37,
  POL_ZACHODNIOPOMORSKIE = 38,

  // Hungary
  HUN_BACS_KISKUN = 96,
  HUN_BARANYA = 97,
  HUN_BEKES = 98,
  HUN_BORSOD_ABAUJ_ZEMPLEN = 99,
  HUN_BUDAPEST = 100,
  HUN_CSONGRAD_CSANAD = 101,
  HUN_FEJER = 102,
  HUN_GYOR_MOSON_SOPRON = 103,
  HUN_HAJDU_BIHAR = 104,
  HUN_HEVES = 105,
  HUN_JASZ_NAGYKUN_SZOLNOK = 106,
  HUN_KOMAROM_ESZTERGOM = 107,
  HUN_NOGRAD = 108,
  HUN_PEST = 109,
  HUN_SOMOGY = 110,
  HUN_SZABOLCS_SZATMAR_BEREG = 111,
  HUN_TOLNA = 112,
  HUN_VAS = 113,
  HUN_VESZPREM = 114,
  HUN_ZALA = 115,

  // Romania
  ROU_AB = 116,
  ROU_AR = 117,
  ROU_AG = 118,
  ROU_BC = 119,
  ROU_BH = 120,
  ROU_BN = 121,
  ROU_BT = 122,
  ROU_BV = 123,
  ROU_BR = 124,
  ROU_BZ = 125,
  ROU_CS = 126,
  ROU_CL = 127,
  ROU_CJ = 128,
  ROU_CT = 129,
  ROU_CV = 130,
  ROU_DB = 131,
  ROU_DJ = 132,
  ROU_GL = 133,
  ROU_GR = 134,
  ROU_GJ = 135,
  ROU_HR = 136,
  ROU_HD = 137,
  ROU_IL = 138,
  ROU_IS = 139,
  ROU_IF = 140,
  ROU_MM = 141,
  ROU_MH = 142,
  ROU_MS = 143,
  ROU_NT = 144,
  ROU_OT = 145,
  ROU_PH = 146,
  ROU_SM = 147,
  ROU_SJ = 148,
  ROU_SB = 149,
  ROU_SV = 150,
  ROU_TR = 151,
  ROU_TM = 152,
  ROU_TL = 153,
  ROU_VS = 154,
  ROU_VL = 155,
  ROU_VN = 156,
  ROU_B = 157,
}
